import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { NatureEnum } from '../types/nature';
import { WorksheetEntry } from '../types/worksheet-entry';
import { EntrySource, WorksheetEntryTypeEnum } from '../types/worksheet';

export type CreateWorksheetEntryRequest = {
    entry: {
        description?: string;
        nature?: NatureEnum;
        amount?: number;
        date?: string;
        attachments?: string[];
        type?: WorksheetEntryTypeEnum;
        source?: EntrySource;
    };
};

async function createWorksheetEntry(
    workpaperId: string,
    req: CreateWorksheetEntryRequest,
    worksheetId: string
): Promise<PostResponseBody<WorksheetEntry>> {
    const { data } = await api.post(`/workpapers/${workpaperId}/worksheets/${worksheetId}/entries`, req);
    return data;
}

export function useCreateWorksheetEntry(
    worksheetId: string
): UseMutationResult<PostResponseBody<WorksheetEntry>, AxiosError, CreateWorksheetEntryRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => createWorksheetEntry(workpaperId, req, worksheetId), {
        onSettled: () => {
            queryClient.invalidateQueries(['entries', worksheetId]);
            queryClient.invalidateQueries(['worksheets', worksheetId]);
            queryClient.invalidateQueries(['worksheets', workpaperId]);
        },
    });
}
